import React, { PureComponent } from 'react';
import Tooltip from 'rc-tooltip';

import RcSlider from '~/core/scripts/components/Slider';

import { numberFormat } from '~/core/scripts/utils';
import { colorScale } from '../SalaryApp/utils';
import ac from '../appconfig';

const gradient = `
  linear-gradient(
    to right,
    ${colorScale(ac.minSalary)} 0%,
    ${colorScale(ac.maxSalary * 0.25)} 25%,
    ${colorScale(ac.maxSalary * 0.5)} 50%,
    ${colorScale(ac.maxSalary * 0.75)} 75%,
    ${colorScale(ac.maxSalary)} 100%
  )
`;

function getPlacement(value) {
  if (value > ac.maxSalary * 0.9) {
    return 'topRight';
  }

  if (value < ac.minSalary + (ac.maxSalary * 0.1)) {
    return 'topLeft';
  }

  return 'top';
}

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  const placement = getPlacement(value);

  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={`${numberFormat(value)} €`}
      visible
      placement={placement}
      key={index}
      getTooltipContainer={()=>document.getElementById('salary__slider')}
    >
      <RcSlider.Handle value={value} {...restProps} />
    </Tooltip>
  );
};

class Slider extends PureComponent {
  render() {
    const { value, onChange } = this.props;

    return (
      <div className="salary__slider" id="salary__slider">
        <div className="salary__slider-title"><strong>Ihr Monatsgehalt</strong> (brutto)</div>
        <RcSlider
          min={ac.minSalary}
          max={ac.maxSalary}
          step={ac.sliderStep}
          included={false}
          value={value}
          onChange={onChange}
          handle={handle}
          marks={{
            [ac.startSalary]: 'mittleres Gehalt'
          }}
          handleStyle={{
            background: colorScale(value)
          }}
          railStyle={{
            background: gradient
          }}
        />
      </div>
    );
  }
}

export default Slider;
